import React, {
    useCallback,
    useMemo,
} from 'react';
import PropTypes from 'prop-types';
import { useRouterState } from 'app/hooks/useRouterState';

import { StepLayout } from '../StepLayout/StepLayout';
import AuthCheckout from './AuthCheckout';

import { RENDER_CONTEXT_SINGLE_STEP, RENDER_CONTEXT_STEP_BY_STEP, TYPE_CHECKOUT_SINGLE_STEP } from '../stepByStepCheckoutConst';

const authLocales = {
    ru: {
        headerTitle: 'Оформление заказа',
        title: 'Ваш телефон',
    },
    en: {
        headerTitle: 'Checkout',
        title: 'Your phone number',
    },
};


function StepAuthFC(props) {
    const {
        renderContext,
        locale,
        headerTitle: headerTitleProp,

        authState,
        setAuthState,
        handleUserEnteredCode,
        handleOpenNextStep,
        handleSetIsOldUser,
        handleCloseAllSteps,
        pushLead,
        userQuery,
        switchToSingleStepCheckout,
        frame,
        handleCloseCurrentStep,
        handleGoToFirstStep,
    } = props;

    const [routerState] = useRouterState();
    const { history, location } = routerState;

    const lsPhone = sessionStorage.getItem('phone');

    const handleChangeAuthState = useCallback((options) => {
        const { variables: { value } } = options;
        setAuthState(value);
    }, [setAuthState]);

    const handleUserAuthed = ({ userResponse }) => {
        const { data: { user } } = userResponse;
        const isNewUser = user.deliveries.length === 0 && user.successDeliveriesCount === 0;

        const params = new URLSearchParams(window.location.search);

        if (params.has('checkout_type', 'single')) {
            setAuthState('authResult');
            setTimeout(() => {
                switchToSingleStepCheckout(TYPE_CHECKOUT_SINGLE_STEP);
            }, 400);
        } else if (isNewUser) {
            handleOpenNextStep();
            setTimeout(() => {
                setAuthState('authResult');
            }, 400);
        } else {
            setAuthState('authResult');
            setTimeout(() => {
                switchToSingleStepCheckout(TYPE_CHECKOUT_SINGLE_STEP);
            }, 400);
        }
    };

    const handlePhoneEntered = useCallback(() => {
    }, []);

    const isNextStepButtonVisible = authState === 'authResult';

    const headerTitle = headerTitleProp || authLocales[locale].headerTitle;

    const authStepCloseHandler = useMemo(
        () => (frame === 'code' ? handleCloseCurrentStep : handleCloseAllSteps),
        [frame, handleCloseAllSteps, handleCloseCurrentStep],
    );

    return (
        <StepLayout
            {...props}
            handleCloseCurrentStep={authStepCloseHandler}
            handleCloseAllSteps={null}
            isNextStepButtonVisible={isNextStepButtonVisible}
            title={headerTitle}
        >
            <AuthCheckout
                renderContext={renderContext}
                phoneTitle={authLocales[locale].title}
                authState={{ authState }}
                setAuthState={handleChangeAuthState}
                handleUserEnteredCode={handleUserEnteredCode}
                handleUserAuthed={handleUserAuthed}
                userQuery={userQuery}
                enteredPhone={lsPhone}
                pushLead={pushLead}
                phoneAutoFocus={false}
                sumbitPhoneSource="checkout_steps"
                buttonDisabledColor="primary-grey-salt"
                onPhoneEntered={handlePhoneEntered}
                handleOpenNextStep={handleOpenNextStep}
                handleSetIsOldUser={handleSetIsOldUser}
                frame={frame}
                handleGoToFirstStep={handleGoToFirstStep}
            />
        </StepLayout>
    );
}

export const StepAuth = (props) => {
    const {
        renderContext = RENDER_CONTEXT_STEP_BY_STEP,
        headerTitle = null,
    } = props;

    return (
        <StepAuthFC
            {...props}
            renderContext={renderContext}
            headerTitle={headerTitle}
        />
    );
};

StepAuth.propTypes = {
    renderContext: PropTypes.oneOf([RENDER_CONTEXT_SINGLE_STEP, RENDER_CONTEXT_STEP_BY_STEP]),
    locale: PropTypes.string.isRequired,
    headerTitle: PropTypes.string,
    handleOpenNextStep: PropTypes.func.isRequired,

    authState: PropTypes.oneOf(['telephone', 'pincode', 'authResult']).isRequired,
    setAuthState: PropTypes.func.isRequired,
    pushLead: PropTypes.func.isRequired,
    userQuery: PropTypes.shape({
        user: PropTypes.shape({}),
    }).isRequired,
    switchToSingleStepCheckout: PropTypes.func.isRequired,
    handleUserEnteredCode: PropTypes.func.isRequired,
};


/*


  const params = new URLSearchParams(window.location.search);

        // if (params.has('checkout_type', 'single')) {
        //     console.log('case alfa');
        //     dispatch({ type: 'SET_CHECKOUT_TYPE', payload: TYPE_CHECKOUT_SINGLE_STEP });
        //     return;
        // }


*/
